// @flow
// Whitelist of navigation paths that may be used as post-login redirect targets.
// Any path received from an external source (deep link, query param) that is not
// in this list is silently ignored to prevent open-redirect attacks (OWASP MASVS-L1).
export const ALLOWED_REDIRECT_PATHS: $ReadOnlyArray<string> = [
  'dashboard',
  'signUp/deliveryMap',
];
